export class IntervalController {
  public running = false;
  private interval = 0;
  private callback = () => {};
  private callOnStart = false;
  private timerId: ReturnType<typeof setInterval> | null = null;
  // Tracks when the callback last fired so tryFireOnce and callOnStart
  // can enforce a cooldown equal to `interval`.
  private lastFiredAtMs = 0;

  constructor(callback: () => void, interval: number, callOnStart: boolean = false) {
    this.callback = callback;
    this.interval = interval;
    this.callOnStart = callOnStart;
    this.running = false;
  }

  private fireAndRecordTime() {
    this.lastFiredAtMs = performance.now();
    this.callback();
  }

  /**
   * Fire the callback once if enough time has elapsed since the last fire.
   * Useful for gating manual/one-shot triggers to the same rate as the
   * interval (e.g. preventing autoclickers from exceeding the interval).
   */
  tryFireOnce() {
    if (performance.now() - this.lastFiredAtMs >= this.interval) {
      this.fireAndRecordTime();
    }
  }

  start() {
    if (!this.running) {
      this.running = true;

      // Respect cooldown even on immediate fire so rapid stop/start
      // cycles can't bypass the interval.
      if (this.callOnStart) {
        this.tryFireOnce();
      }

      this.timerId = setInterval(() => {
        if (!this.running) return;
        this.fireAndRecordTime();
      }, this.interval);
    }
  }

  stop() {
    this.running = false;
    if (this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }

  setInterval(newInterval: number) {
    this.interval = newInterval;
    if (this.running && this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = setInterval(() => {
        if (!this.running) return;
        this.fireAndRecordTime();
      }, this.interval);
    }
  }
}
